import { Menu, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { OrderBy } from "../../../components/QueryBuilder/OrderBy";
import { uiStorage } from "../../../redux/UI/ui.actions";
import { FullUI } from "../../../redux/UI/ui.selectors";
import { HorizontalStack, SmartContainer } from "../../../styles/Containers";
import { StyledIconButton } from "../../../styles/matieralui/IconButton";
import { IconSort, IconSortFilled } from "../../Icons";
export const SortBy = ({ storageKey, options, value, onChange }) => {

    const dispatch = useDispatch();
    const ui = FullUI();
    const [anchor, setAnchor] = useState(null);

    const openMenu = (event) => setAnchor(event.currentTarget);
    const closeMenu = () => setAnchor(null);

    const handleChange = (v) => {

        // Save Change
        dispatch(uiStorage({ [storageKey]: v }))

        // Handle Change
        onChange(v);
    }


    return (

        <HorizontalStack flex align="center" justify="flex-end">
            <Tooltip title="Sort By" placement="top">
                <StyledIconButton onClick={openMenu}>
                    {value && (<IconSortFilled />)}
                    {!value && (<IconSort />)}
                </StyledIconButton>
            </Tooltip>
            <Menu
                open={Boolean(anchor)}
                onClose={closeMenu}
                anchorEl={anchor}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <SmartContainer style={{ margin: "10px" }}>
                    <OrderBy
                        value={value}
                        onChange={handleChange}
                        options={options}
                    />
                </SmartContainer>
            </Menu>
        </HorizontalStack>

    )
}